import { defineMessages } from 'react-intl';

export { AnimationDelay } from './animationDelay';

export const LOCATIONS_CAROUSEL_KEY = '@@locationsCarousel';

export const LOCALIZED_STRINGS = defineMessages({
    CheckingInsurance: {
        id: 'Components.LocationCardCarousel.CheckingInsurance',
        defaultMessage: 'Checking your insurance...',
    },
    InsuranceAccepted: {
        id: 'Components.LocationCardCarousel.InsuranceAccepted',
        defaultMessage: 'Your insurance is accepted here',
    },
    InsuranceNotAccepted: {
        id: 'Components.LocationCardCarousel.InsuranceNotAccepted',
        defaultMessage: 'Your insurance is not accepted here',
    },
    LocationCarouselIndex: {
        id: 'Components.LocationCardCarousel.LocationCarouselIndex',
        defaultMessage: '{index} / {total}',
    },
});
